// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container {
    position: fixed;
    background-color: transparent;
    width: 100%;
    height: 100vh;
    z-index: 99;
    top: 0;
    display: block;
  }
  
  #loader {
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 120px;
    height: 120px;
    margin: -76px 0 0 -76px;
    border: 12px solid #ffcc00;
    border-radius: 50%;
    border-top: 16px solid #252B48;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2.5s linear infinite;
  }
  
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }`, "",{"version":3,"sources":["webpack://./src/styles/loader.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,6BAA6B;IAC7B,WAAW;IACX,aAAa;IACb,WAAW;IACX,MAAM;IACN,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;IAClB,8BAA8B;IAC9B,0CAA0C;IAC1C,oCAAoC;EACtC;;EAEA;IACE,KAAK,+BAA+B,EAAE;IACtC,OAAO,iCAAiC,EAAE;EAC5C;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC","sourcesContent":[".loader-container {\n    position: fixed;\n    background-color: transparent;\n    width: 100%;\n    height: 100vh;\n    z-index: 99;\n    top: 0;\n    display: block;\n  }\n  \n  #loader {\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    z-index: 1;\n    width: 120px;\n    height: 120px;\n    margin: -76px 0 0 -76px;\n    border: 12px solid #ffcc00;\n    border-radius: 50%;\n    border-top: 16px solid #252B48;\n    -webkit-animation: spin 2s linear infinite;\n    animation: spin 2.5s linear infinite;\n  }\n  \n  @-webkit-keyframes spin {\n    0% { -webkit-transform: rotate(0deg); }\n    100% { -webkit-transform: rotate(360deg); }\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
